import { DefaultTheme } from "styled-components";

import {
    colors,
    fontSizes,
    fontWeights,
    lineHeights,
    responsiveBreakPoints,
    spacings,
    layout,
} from "./DesignVariables";

export const ecommReviews: DefaultTheme = {
    theme: "ecommReviews",
    colors: colors,
    media: responsiveBreakPoints,
    fontSizes: fontSizes,
    spacings: spacings,
    lineHeights: lineHeights,
    fontWeights: fontWeights,
    layout: layout,
};
